module.exports = __webpack_public_path__ + "static/img/welfare3.fc5d7cd2.jpg";